const SHOW_CODE = 'scratch-gui/code/SHOW_CODE';
const CLEAR_CODE = 'scratch-gui/code/CLEAR_CODE'; // TODO, 可以通过showCode传空实现
const SET_BURN_RESULT = 'scratch-gui/code/SET_BURN_RESULT';
const CLEAR_BURN_RESULT = 'scratch-gui/code/CLEAR_BURN_RESULT'; // TODO
const AIXIONG_SOCKET = 'scratch-gui/code/AIXIONG_SOCKET';
const AIXIONG_ADAPTOR = 'scratch-gui/code/AIXIONG_ADAPTOR';
const AIXIONG_BURNING = 'scratch-gui/code/AIXIONG_BURNING';
const AIXIONG_GUITOVM = 'scratch-gui/code/AIXIONG_GUITOVM';
const AIXIONG_MYSOCKET = 'scratch-gui/code/AIXIONG_MYSOCKET';


const CHART_DATA = 'scratch-gui/code/CHART_DATA'; // TODO, 因该单独新建一个数据图表的reducer


const initialState = {
    code: '',
    burnResult: {},
    chartData: {},
    count: 0,
    socket: null,
    adaptor: false,
    burning: false,
    guiTovm: {
        state: false,
        method: '',
        data: ''
    },
    mySocket: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SHOW_CODE:
            return Object.assign({}, state, {
                code: action.code
            });
        case SET_BURN_RESULT:
            let message = action.burnResult.message
            // message =  message.replace(/\r/g, '\n')
            let msgArr = message.split(/\n/g) // /[\n\r]/g
            if (msgArr.length > 500) {
                msgArr.splice(0, msgArr.length - 500)
            }
            message = msgArr.join('\n')
            // message = msgArr.join('\r')

            return Object.assign({}, state, {
                burnResult: {
                    status: action.burnResult.status,
                    message
                }
            });
        case CHART_DATA:
            return Object.assign({}, state, {
                chartData: action.chartData,
                count: state.count + 1,
            });
        case AIXIONG_SOCKET:
            return Object.assign({}, state, {
                socket: action.socket
            });
        case AIXIONG_MYSOCKET:
            return Object.assign({}, state, {
                mySocket: action.mySocket
            });
        case AIXIONG_ADAPTOR:
            return Object.assign({}, state, {
                adaptor: action.adaptor
            });
        case AIXIONG_BURNING:
            return Object.assign({}, state, {
                burning: action.burning
            });
        case AIXIONG_GUITOVM:
            return Object.assign({}, state, {
                guiTovm: action.guiTovm
            });
        default:
            return state;
    }
};

const showCode = function (code) {
    return {
        type: SHOW_CODE,
        code: code
    };
};

const setBurnResult = function (burnResult) {
    return {
        type: SET_BURN_RESULT,
        burnResult: burnResult
    };
};

const sendChartData = function (chartData) {
    return {
        type: CHART_DATA,
        chartData: chartData
    };
};

const setSocket = function (socket) {
    return {
        type: AIXIONG_SOCKET,
        socket
    };
};
const setMySocket = function (mySocket) {
    return {
        type: AIXIONG_MYSOCKET,
        mySocket
    };
};
const setAdaptor = function (adaptor) {
    return {
        type: AIXIONG_ADAPTOR,
        adaptor
    };
};
const setBurning = function (burning) {
    return {
        type: AIXIONG_BURNING,
        burning
    };
};
const setGuiTovm = function (guiTovm) {
    return {
        type: AIXIONG_GUITOVM,
        guiTovm
    };
};

export {
    reducer as default,
    initialState as codeInitialState,
    showCode,
    setBurnResult,
    sendChartData,
    setSocket,
    setMySocket,
    setAdaptor,
    setBurning,
    setGuiTovm
};
